__turbopack_context__.v({
  "title-wrapper": "styles-module__C6wzCq__title-wrapper",
});
